<template>
	<div class="job-selector">
		<div class="job-selector-header tw-text-center">
				<info-icon v-if="showInfoIcon" class="info-icon" @click="$emit('infoClick')" />
				<div v-if="!flagEditName" class="tw-flex tw-justify-center tw-items-center tw-gap-x-2">
					<h4 class="tw-mb-2">Puesto / {{ selectedJob.name }}</h4>
					<app-btn
						:img="`${$imageUrl}/edit.svg`"
						text="Editar nombre de Puesto"
						@click-icon="editName"
					/>
				</div>
				<div v-if="flagEditName" class="tw-flex tw-w-auto tw-justify-center tw-items-center tw-gap-x-0">
					<v-text-field
					solo
					class="input-text"
					v-model="jobCopied.name"
					@input="onSelectChange"
				></v-text-field>
					<app-btn
						img="/static/img/close1.svg"
						text="Cancelar"
						@click-icon="cancelEdition"
					/>
				</div>
				<p class="tw-mb-0" v-html='cardDescription'></p>
		</div>
		<div class="job-selector-body">
			<c-job-verbs-selector
				v-show="currentPage === 1"
				:verbs-info="verbsSelection"
				:selected-job="selectedJob"
				@selectedJobDataChanged="$emit('selectedJobDataChanged', $event)"
			/>
			<c-job-level-selector
				:level-info="levelSelection"
				:selected-job="selectedJob"
				v-show="currentPage === 2"
				@addNewArea="$emit('addNewArea', $event)"
				@selectedJobDataChanged="$emit('selectedJobDataChanged', $event)"
			/>
		</div>
		<c-job-selector-navigation
			:current-page="currentPage"
			@prevPageClick="prevLocalPage"
			@nextPageClick="nextLocalPage"
			@prevItemClick="onPrevClick"
			@nextItemClick="onNextClick"
			:job-list-navigation="jobListNavigation"
			:selected-next="selectedNext"
			:selected-prev="selectedPrev"
		/>
		<div class="job-selector-footer tw-text-center">
			<slot name="action-footer" />
		</div>
	</div>
</template>

<script>
import cJobVerbsSelector from '@/modules/job-profile/components/jobs-profile/job-info-edition/job-verbs-selector';
import cJobLevelSelector from '@/modules/job-profile/components/jobs-profile/job-info-edition/job-level-selector';
import InfoIcon from '@/modules/shared/components/icons/info-icon';
import { mapState } from 'vuex';
import { clone, path } from 'ramda';
import cJobSelectorNavigation from '@/modules/job-profile/components/jobs-profile/job-info-edition/job-selector-navigation';

export default {
	name: 'guideline-job-selector',
	components: {
		cJobSelectorNavigation,
		InfoIcon,
		cJobLevelSelector,
		cJobVerbsSelector,
	},
	props: {
		selectedJob: { default: () => ({}) },
		selectedPrev: { default: () => ({}) },
		selectedNext: { default: () => ({}) },
		jobListNavigation: { default: false },
		showInfoIcon: { default: false },
	},
	computed: {
		...mapState('jobEvaluation', {
			verbsSelection: path(['supplies', 'guidelineModel', 'verbsSelection']),
			levelSelection: path(['supplies', 'guidelineModel', 'levelSelection']),
		}),
		cardDescription() {
			const jobName = `<span style='text-transform: uppercase'>${this.selectedJob.name}</span>`;
			return this.currentPage === 1 ?
				`Marca los verbos que realiza el puesto de ${jobName}` :
				`Marca los niveles que realiza el puesto de ${jobName}`;
		},
	},
	data() {
		return {
			currentPage: 1,
			flagEditName: false,
			jobCopied: {},
		};
	},
	methods: {
		nextLocalPage() {
			this.currentPage = 2;
		},
		prevLocalPage() {
			this.currentPage = 1;
		},
		onPrevClick() {
			this.nextLocalPage();
			this.$emit('prevClick');
		},
		onNextClick() {
			this.prevLocalPage();
			this.$emit('nextClick');
		},
		editName() {
			this.flagEditName = true;
		},
		cancelEdition() {
			this.flagEditName = false;
		},
		onSelectChange() {
			this.$emit('selectedJobDataChangedName', clone(this.jobCopied));
		},
	},
	watch: {
		selectedJob: {
			deep: true,
			handler(val) {
				this.jobCopied = clone(val);
			},
		},
	},

};
</script>

<style lang='scss' scoped>
.job-selector {
border-radius: 10px;
border: solid 1px var(--app-color-gray);
background-color: #ffffff;
.job-selector-header {
	padding: 20px;
	position: relative;
	cursor: pointer;
	h4 {
		color: var(--app-color-primary);
		text-transform: uppercase;
		font-size: 16px;
	}
	p {
		font-size: 12px;
		color: #494949;
		span {
			text-transform: uppercase;
		}
	}
	.info-icon {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 1;
		svg, path {
			fill: var(--app-color-primary);
		}
	}
}
.job-selector-body {
	min-height: 300px;
}
.job-selector-footer {
	padding: 20px;
	p {
		color: #9b9b9b;
		font-size: 12px;
	}
}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/jobs-profile/job-selector.vue